import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateFullWidthRow(section, block) {

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
    },
  });

  tl.to(block, {
    duration: 0.8,
    opacity: 1,
    scale: 1,
    ease: "power2.out",
  });

}